import { South } from "@mui/icons-material"
import { styled } from "@mui/material"
import type { PropsWithChildren } from "react"

export const TableReviewCsv = ({ children }: PropsWithChildren) => (
  <Table>
    <tbody>{children}</tbody>
  </Table>
)

const Table = styled("table")(({ theme }) => ({
  marginBottom: theme.spacing(2),
  borderCollapse: "collapse",
  width: "100%",
}))

export const RowReviewCsv = styled("tr")({
  "& td:first-of-type": { borderLeft: "none" },
  "& td:last-child": { borderRight: "none" },
})

export const CellReviewCsv = styled("td")(({ theme }) => ({
  border: "1px solid #e1e4e8",
  padding: theme.spacing(1, 2),
  ...theme.typography["14px"],
  color: theme.palette.grey.dark,
}))

export const OrangeCellReviewCsv = styled(CellReviewCsv)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.common.orangeDark2,
}))

export const ArrowDownReviewCsv = styled(South)(({ theme }) => ({
  marginTop: "28px",
  color: theme.palette.common.electricBlue,
}))

export const BlueTextReviewCsv = styled("span")(({ theme }) => ({
  color: theme.palette.common.electricBlue,
  textDecoration: "underline",
}))
